import React from "react";
import "./OurCapabilities.css";
import RichTextContent, { CmsText } from "../../../RichTextContent/RichTextContent";

import icon1 from "../../../../assets/icons/capabilities/icon1.svg";
import icon2 from "../../../../assets/icons/capabilities/icon2.svg";
import icon3 from "../../../../assets/icons/capabilities/icon3.svg";
import icon4 from "../../../../assets/icons/capabilities/icon4.svg";
import icon5 from "../../../../assets/icons/capabilities/icon5.svg";
import icon6 from "../../../../assets/icons/capabilities/icon6.svg";

import { useHomeSection } from "../../../../context/HomePageContext";
import { getCardsFromSection } from "../../../../services/contentApi";
import { stripRichText } from "../../../../utils/richText";

const icons = [icon1, icon2, icon3, icon4, icon5, icon6];

const OurCapabilities = () => {
  const { section, loading } = useHomeSection("capabilities");

  if (loading || !section?.fields) return null;

  const fields = section.fields;
  const cards = getCardsFromSection(section);

  return (
    <section className="capabilities">
      <div className="capabilitiestop">
        {fields.subtitle ? (
          <CmsText
            content={fields.subtitle}
            as="p"
            className="capabilities-subtitle"
          />
        ) : null}

        {fields.title ? (
          <CmsText
            content={fields.title}
            as="h2"
            className="capabilities-title"
          />
        ) : null}

        {fields.description ? (
          <RichTextContent
            content={fields.description}
            className="capabilities-description"
          />
        ) : null}
      </div>

      <div className="capabilitiesbottom">
        {cards.map((card, i) => (
          <div className="cap-card" key={i}>
            <div className="icon">
              <img src={icons[i]} alt={stripRichText(card.title)} />
            </div>
            <CmsText content={card.title} as="h3" />
            <RichTextContent content={card.description} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default OurCapabilities;
